// Product card > Show next photo by scrolling (mobile):
// 1) flyttar det aktiva strecket längst ned när man swipar (ett delegerat scroll-lyssnare för hela sidan); strecket
//    är osynligt tills man swipar och tonas ut igen 2 sekunder efter senaste scroll
// 2) förladdar extra bilder: de ligger utanför bildbandets klippta yta, så loading="lazy" laddar dem annars först när
//    de scrollas in (blank bild vid första swipen). Nästa bild hämtas när kortet legat i bild en stund, resten när man börjar swipa.
(() => {
  let frame = 0;

  const extras = (swipe) => swipe.querySelectorAll('.product-card__slide--extra img');
  const load = (images) => images.forEach((img) => { if (img.loading === 'lazy') img.loading = 'eager'; });

  const hideTimers = new WeakMap();
  const showBar = (swipe) => {
    const bar = swipe.closest('.product-card__figure')?.querySelector('.product-card__swipe-dots');
    if (!bar) return;
    bar.classList.add('is-visible');
    clearTimeout(hideTimers.get(bar));
    hideTimers.set(bar, setTimeout(() => bar.classList.remove('is-visible'), 2000));
  };

  const update = (swipe) => {
    const slideWidth = swipe.clientWidth;
    if (!slideWidth) return;
    const index = Math.round(Math.abs(swipe.scrollLeft) / slideWidth);
    const dots = swipe.closest('.product-card__figure')?.querySelectorAll('.product-card__swipe-dots > span');
    dots?.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  };

  document.addEventListener('scroll', (event) => {
    const target = event.target;
    if (!(target instanceof Element) || !target.classList.contains('product-card__swipe')) return;
    load(extras(target));
    showBar(target);
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => update(target));
  }, { capture: true, passive: true });

  const dwellTimers = new WeakMap();
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      clearTimeout(dwellTimers.get(target));
      if (!isIntersecting) return;
      dwellTimers.set(target, setTimeout(() => {
        load([...extras(target)].slice(0, 1));
        observer.unobserve(target);
      }, 400));
    });
  }, { threshold: 0.6 });

  const observeNew = () => {
    document.querySelectorAll('.product-card__swipe:not([data-swipe-seen])').forEach((swipe) => {
      swipe.dataset.swipeSeen = '';
      observer.observe(swipe);
    });
  };

  const start = () => {
    observeNew();
    let pending = 0;
    new MutationObserver(() => {
      clearTimeout(pending);
      pending = setTimeout(observeNew, 250);
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'complete') start();
  else addEventListener('load', start);
})();
